import React, { useState, useEffect } from 'react'
import { GET_STATES, GET_CUSTOMER_LIST } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import Select from 'react-select';
import { GST_TYPES } from '../../../data/constant';
import { useTranslation } from 'react-i18next';
import CustomerModal from '../../modals/CustomerModal';

export default function SelectVendor({ remitVendor, vendorId }) {

     const [vendorList, setVendorList] = useState([]);
     const [vendorOption, setVendorOption] = useState([]);
     const [states, setStates] = useState([]);
     const [vendor, setVendor] = useState({});
     const [selectedOption, setVendorSelectedOption] = useState(null);
     const [stateSelectedOption, setStateSelectedOption] = useState(null);
     const [customerModal, setCustomerModal] = useState(false);
     const [loading, setLoading] = useState(false);

     const { t } = useTranslation();

     useEffect(() => {
          getVendorList();
          getState();
          setVendorFromProps();
     }, [])

     useEffect(() => {
          remitData();
     }, [selectedOption, stateSelectedOption])

     useEffect(() => {
          setVendorFromProps();
     }, [vendorId])

     const getVendorList = async (input = '') => {
          setLoading(true);
          let payload = { customerType: 1, string: input }
          const res = await httpClient.sendRequest(GET_CUSTOMER_LIST, payload);
          setLoading(false);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    let data = result.data;
                    setVendorList(data);
                    let option = [];
                    data.forEach(element => {
                         option.push({ label: `${element.full_name} [${element.mobile}]`, value: element.customer_id });
                    });
                    setVendorOption(option);
               }
          }
     }

     const handleInputChange = (inputValue, { action }) => {
          if (action === 'input-change') {
               getVendorList(inputValue);
          }
     };

     const setVendorFromProps = () => {
          if (vendorId && vendorList) {
               const foundVendor = vendorList.find(element => element.customer_id === vendorId);
               if (foundVendor) {
                    setVendorSelectedOption({ label: `${foundVendor.full_name} [${foundVendor.mobile}]`, value: foundVendor.customer_id });

               }
               findVendor(vendorId);
          }
     }

     const onVednorChange = (selectedOption) => {
          setVendorSelectedOption(selectedOption);
          findVendor(selectedOption.value);
     };

     const onStateChange = (selectedOption) => {
          setStateSelectedOption(selectedOption);
          setVendor(preVendor => ({
               ...preVendor,
               state: selectedOption.value
          }));
     };

     const findVendor = (vendor_id) => {
          const foundVendor = vendorList.find(element => element.customer_id === vendor_id);
          if (foundVendor) {
               setVendor(foundVendor);
               const state = states.find(element => element.value === foundVendor.state);
               if (state) {
                    setStateSelectedOption(state);
               } else {
                    setStateSelectedOption(null);
               }
          }
     };

     const getState = async (e) => {
          const res = await httpClient.post(GET_STATES, {});
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    let options = [];
                    result.data.forEach((row, index) => {
                         options.push({ label: row.name, value: row.id });
                    });
                    setStates(options);
               }
          }
     }

     const remitData = () => {
          if (selectedOption !== null) {
               let s = stateSelectedOption ? stateSelectedOption.value : null;
               const data = { vendor: vendor, vendor_id: selectedOption.value, state_id: s }
               remitVendor(data);
          }
     }

     const customerModalAction = (status = false) => {
          setCustomerModal(status);
          getVendorList();
     }

     return (
          <div className='py-1 bg-light'>
               <div className='row'>
                    <div className='col-md-6'>
                         <label className='mb-0'>{t('select_vendor')}</label>  <button style={{ cursor: "pointer" }} className='btn btn-sm btn-outline-primary btn-fw' onClick={(e) => customerModalAction(true)}>+</button>
                         <Select
                              autoFocus
                              id='vendor_id'
                              value={selectedOption}
                              options={vendorOption}
                              isSearchable={true}
                              placeholder="Select"
                              onChange={onVednorChange}   
                              onInputChange={handleInputChange}
                              isLoading={loading}                          
                         />
                         {Object.keys(vendor).length > 0 && <small>{t('gst_number')} : {vendor.gst_number} <br />{t('type')} : {GST_TYPES[vendor.gst_type]}</small>}
                    </div>
                    {Object.keys(vendor).length > 0 &&
                         <div className='col-md-6'>
                              <label className='mb-0' htmlFor='play_of_supply'>{t('play_of_supply')} : </label>
                              <Select
                                   id='play_of_supply'
                                   value={stateSelectedOption}
                                   options={states}
                                   isSearchable={true}
                                   placeholder="Select"
                                   onChange={onStateChange}
                              />
                              <label className='mb-0' htmlFor='billing_address'><small>{t('billing_address')}
                                   {t('address')} : {vendor.address},{t('city')} : {vendor.city}, {t('pincode')} : {vendor.pincode}</small>
                              </label>
                         </div>
                    }
                    <CustomerModal show={customerModal} handleClose={customerModalAction} vendor={true} />
               </div>
          </div>
     )
}
